import React, { useState, useEffect, useRef } from 'react'
import { Button, Card, Col, Form, Icon, Input, Table, Popconfirm, Row, notification, Tooltip } from 'antd'
import GetEachFormFields from '../components/_utils/appFormUtils'

import _ from 'lodash'
import PageHeaderWrapper from '../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils-lite'
import { DefaultTablePagination, DisplayDate } from '../components/_utils/appUtils'
import { ArticleSearchById, ArticleSearchResultsFxn } from './article/actions'
import { useDispatch } from 'react-redux'
import ReactHtmlParser from 'react-html-parser'

const nationalityList = [
  'Indian',
  'Foreign'
]
const searchResults = (props) => {
  const dispatch = useDispatch()
  const { form: { getFieldDecorator, getFieldValue, setFieldsValue }, callback } = props
  const [searchTerm, setSearchTerm] = useState('')
  const [searchResults, setSearchResults] = useState([])
  let tableRef = useRef()
  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      if (searchTerm && searchTerm.trim().length >= 3) {
        params.query = searchTerm
        let resp = await dispatch(ArticleSearchResultsFxn(params))
        resolve(resp)
      } else {
        resolve({})
      }
    })
  }

  const searchArticle = async () => {
    setTimeout(() => {
      tableRef.current.reload()
    }, 300)
  }
  const clearFxn = () => {
    setSearchTerm('')
    setTimeout(() => {
      tableRef.current.reload()
    }, 300)
  }
  const columns = [
    {
      key: 'actions',
      title: 'Article Id',
      render: (val, record) => (
        <Tooltip title='Edit Details'>
          <a href={`/articleView/${record._id}`}>
            {record.articleNo}
          </a>
        </Tooltip>

      )
    },
    {
      title: 'Submitted Date',
      key: 'submittedDate',
      dataIndex: 'submittedDate',
      width: 100,
      render: (item) => {
        return item ? DisplayDate(item) : null
      }
    },

    {
      title: 'Article Title',
      dataIndex: 'manuScriptTitle',
      align: 'center',
      key: 'manuScriptTitle',
      render: (text, record, index) => {
        return (
          <>
            {ReactHtmlParser(record.manuScriptTitle)}
          </>
        )
      }
    },
    {
      title: 'Journal',
      dataIndex: 'journal',
      key: 'journal',
      align: 'center',
      searchTextName: 'journal'

    },

    {
      title: 'Country',
      key: 'country',
      dataIndex: 'country'
    },
    {
      title: 'Author',
      key: 'correspondingAuthor',
      dataIndex: 'correspondingAuthor'
    },
    {
      title: 'Email',
      key: 'correspondingAuthorsEmail',
      dataIndex: 'correspondingAuthorsEmail'
    },

    {
      title: 'Volume',
      key: 'volumeName',
      filterRegex: true,
      dataIndex: 'volumeName'
    },
    {
      title: 'Issues',
      key: 'issues',
      filterRegex: true,
      dataIndex: 'issues'
    },
    {
      title: 'Doi Number',
      dataIndex: 'doiNumber',
      key: 'doiNumber',
      align: 'center',
      searchTextName: 'doiNumber'

    },

    {
      title: 'Author',
      dataIndex: 'authors',
      key: 'authors',
      align: 'center',
      render: (authors) => (
        <>
          {Array.isArray(authors) && authors.length > 0 ? (
            authors.map((author, idx) => (
              <div key={idx} style={{ marginBottom: 8 }}>
                <div><strong>Name:</strong> {author.name || '-'}</div>
                <div><strong>Designation:</strong> {author.designation || '-'}</div>
                <div><strong>Email:</strong> {author.email || '-'}</div>
              </div>
            ))
          ) : (
            <div>-</div>
          )}
        </>
      )
    }
  ]
  return (
    <>

      <PageHeaderWrapper title={`Search Results`}>

        <Card bordered={true}>
          <Form hideRequiredMark className={'inputForm'} style={{ marginBottom: '30px' }}>

            <Row gutter={16}>
              <Col span={6}>
                <Input className={'antInputSearch'}
                       placeholder={'Search your Author Email, name and article title'}
                       style={{ marginRight: '10px' }}
                       value={searchTerm}
                       onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Col>
              <Button
                key='1'
                type='primary'
                onClick={searchArticle}
                style={{ marginRight: '10px' }}
              >
                Search
              </Button>
              <Button
                key='1'
                type='primary'
                onClick={clearFxn}>
                Clear
              </Button>


            </Row>
          </Form>

          <TableComp
            ref={tableRef}
            columns={columns}
            apiRequest={apiRequest}
            pagination={DefaultTablePagination({}, 10)}
          />
        </Card>
      </PageHeaderWrapper>
    </>

  )
}

const WrappedDashboardFilter = Form.create()(searchResults)
export default WrappedDashboardFilter
